/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Not_Taken_Part_BodyInputs */



/**
* | output |
* | --- |
* | "So there is nothing to rate yet. Try again when you’re ready." |
*
* @param {Practice_Not_Taken_Part_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_not_taken_part_body = /** @type {((inputs?: Practice_Not_Taken_Part_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Not_Taken_Part_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Er valt dus nog niets te beoordelen. Probeer het opnieuw wanneer je er klaar voor bent.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il n’y a donc encore rien à évaluer. Réessayez quand vous serez prêt.")
	return /** @type {LocalizedString} */ ("So there is nothing to rate yet. Try again when you’re ready.")
});